import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import GetStartedUsername from './GetStartedUsername';
import GetStartedNames from './GetStartedNames';
import { GET_STARTED, GET_STARTED_STEPS, EVAL_INTRO } from './ConstPaths';

const propTypes = {
  providerName: PropTypes.string,
  clientName: PropTypes.string,
  clientUsername: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  updateSession: PropTypes.func.isRequired
};

const defaultProps = {
  providerName: '',
  clientName: 'the client',
  pronouns: ['they', 'them', 'their'],
};

//Manage the wizard form for the Get Started section
//Initialize the forms with props and manage those as local state.
//On Continue, update the global Session state with the local state from the forms. 
// Following pattern described in https://goshacmd.com/wizard-form-collect-info/
//NOTE: this 'wizard' has only 1 step, so we don't currently need to step management,
//but the local state, componentDidUpdate, etc. from the wizard pattern is all useful

const BASE_URL = GET_STARTED + "/";
//the steps of the wizard form:
const steps = GET_STARTED_STEPS;

const NEXT_SECTION = EVAL_INTRO;

class GetStarted extends React.Component {
  constructor(props) {
    super(props);
    //manage the incoming values as local state
    this.state = {
      providerName: this.props.providerName,
      clientName: this.props.clientName,
      clientUsername: this.props.clientUsername
    };

    this.saveProviderName = this.saveProviderName.bind(this);
    this.saveClientName = this.saveClientName.bind(this);
    this.saveClientUsername = this.saveClientUsername.bind(this);
    this.saveNames = this.saveNames.bind(this);
    this.onContinue = this.onContinue.bind(this);
  }

  //Get the current step from the URL
  getCurrentStep(){
    //e.g. URL of '/get-started/names' would have step of 'names'
    const stepParam = this.props.match.params.step;
    if(stepParam){
      console.log("GetStarted.getCurrentStep: got step from URL");
      return(stepParam);
    }
    else{
      console.log("GetStarted.getCurrentStep: using default step");
      return(steps.USERNAME);
    }
  }

  //On Continue for a given step:
  // figure out the next step and go to it
  // and if we're totally done with this section, submit the data.
  //For Cognition section, we only have one step, but doing it this way
  //is parallel to all the other sections, and allows us to easily add steps.
  onContinue() {
    let history = this.props.history;
    let nextStep = '';
    let nextRoute = '';
    let goToNextSection = false;
    const curURL = new URL(window.location.href);


    switch(this.getCurrentStep()){
      case steps.USERNAME:
        nextStep = steps.NAMES;
        break;
      case steps.NAMES:
        nextStep = '';
        goToNextSection = true;
        break;
      default:
        console.log("   default next step");
        nextStep = steps.USERNAME;
    }
    if (!goToNextSection) {
      nextRoute = BASE_URL + nextStep;
    } 
    else {
      // alert("Done with this section. Data saved are: " + JSON.stringify(this.state));
      nextRoute = NEXT_SECTION;
    }
    console.log("    pushing new route: " + nextRoute);
    history.push({
      pathname: nextRoute,
      search: curURL.search
    });
  }

  saveNames(){
    this.saveProviderName();
    this.saveClientName();
  }
  saveProviderName(){
    this.props.updateSession('providerName', this.state.providerName);
  }
  saveClientName(){
    this.props.updateSession('clientName', this.state.clientName);
    //just as a test for now
  }
  saveClientUsername(){
    this.props.updateSession('clientUsername', this.state.clientUsername);
  }

  //called from the child form when the user changes anything
  updateLocalState(key) {
    return evt => {
      const target = evt.target; /* which input has been changed */
      let value = target.type === 'checkbox' ? target.checked: target.value;
      this.setState({ [key]: value });
    }
  }

  //If new props come in after rendering, update the views in this tab.
  //(This occurs when you refresh a view and it pulls data from the database.)
  componentDidUpdate(prevProps, prevState){
    //for simple strings
    if (this.props.providerName !== prevProps.providerName){
        console.log("--incoming props: " + this.props.providerName + " differ from prev props: " + prevProps.providerName);
        this.setState({'providerName': this.props.providerName});
    }
    if (this.props.clientName !== prevProps.clientName){
      console.log("--incoming props: " + this.props.clientName + " differ from prev props: " + prevProps.clientName);
      this.setState({'clientName': this.props.clientName});
  }
  if (this.props.clientUsername !== prevProps.clientUsername){
    console.log("--incoming props: " + this.props.clientUsername + " differ from prev props: " + prevProps.clientUsername);
    this.setState({'clientUsername': this.props.clientUsername});
}
}

  render() {
    console.log("GetStarted.render() props: " + JSON.stringify(this.props));
    const curURL = new URL(window.location.href);
    const searchQuery = curURL.search;

    return(
    <>
    <Switch>
      <Route path={BASE_URL + steps.USERNAME}>
        <GetStartedUsername
            key={steps.USERNAME}
            clientUsername={this.state.clientUsername}
            onChangeClientUsername={this.updateLocalState("clientUsername")}
            saveFormData={this.saveClientUsername}
            onContinue={this.onContinue}
          />
      </Route>
      <Route path={BASE_URL + steps.NAMES}>
        <GetStartedNames
            key={steps.NAMES}
            providerName={this.state.providerName}
            onChangeProviderName={this.updateLocalState("providerName")}
            clientName={this.state.clientName}
            onChangeClientName={this.updateLocalState("clientName")}
            saveFormData={this.saveNames}
            onContinue={this.onContinue}
          />
      </Route>
      <Route path={BASE_URL}>
        <Redirect to={BASE_URL + steps.USERNAME + searchQuery} />
      </Route>
    </Switch>
    </>
    );
  }
}

GetStarted.propTypes = propTypes;
GetStarted.defaultProps = defaultProps;


// withRouter wrapper provides access to the match, location, and history props
// "You can get access to the history object’s properties and the closest <Route>'s match 
// via the withRouter higher-order component. withRouter will pass updated 
// match, location, and history props to the wrapped component whenever it renders"
export default withRouter(GetStarted);
